import { Alert } from "@intellihr/blueberry"

const AlertLoginFailed: React.FC = () => {
    return (
        <div style={{ position: "absolute", width: '100%'}}>
          <Alert tone="critical" testId='unsuccessful-login-alert'>
            Either your username or password is incorrect. Your account may lock out after multiple successive incorrect attempts.
          </Alert>
        </div>
    )
  }
  
export { AlertLoginFailed }
  